import { Card, Col, Row, Tab } from "react-bootstrap";
import BreadcrumbItem from "../../../shared/components/BreadcrumbItem";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PersonalInfo from "./PersonalInfo";
import ChangePassword from "./ChangePassword";
import UserInfo from "./UserInfo";
import { useNavigate, useParams } from "react-router-dom";

const AccountProfile = () => {
  const { t } = useTranslation();
  const { userId } = useParams();
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);

  return (
    <>
      <BreadcrumbItem
        mainTitle={t("user.users")}
        subTitle={userId ? t("user.updateUser") : t("user.createUser")}
      />{" "}
      <Row>
        <Col sm={12}>
          <Tab.Container defaultActiveKey="PersonalInfo">
            <Row>
              <UserInfo
                selectedFile={selectedFile}
                onFileSelect={setSelectedFile}
              />
              <Col lg={7} xxl={9}>
                <Tab.Content id="user-set-tabContent">
                  <Tab.Pane
                    eventKey="PersonalInfo"
                    className="fade"
                    id="user-set-information"
                    role="tabpanel"
                  >
                    <Card>
                      <Card.Header>
                        <h5>{t("general.personalInformation")}</h5>
                      </Card.Header>
                      <Card.Body>
                        <PersonalInfo
                          cancel={() => navigate(-1)}
                          selectedFile={selectedFile}
                        />
                      </Card.Body>
                    </Card>
                  </Tab.Pane>
                  {userId && <ChangePassword />}
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
          <div />
        </Col>
      </Row>
    </>
  );
};

export default AccountProfile;
